import type { ElementType } from "react";
import { useField } from "formik";
import { IconFileText, IconPencil } from "@tabler/icons-react";
// @ts-expect-error pure js
import { classnames } from "../../../utils";
// @ts-expect-error pure js
import Tabs from "../../UI/Tabs";
// @ts-expect-error pure js
import IconAndText from "../../UI/IconAndText";
import ButtonCard from "../../UI/ButtonCard";
import Text from "../../UI/Text";
import styles from "./GenBailChoice.module.css";

interface OptionProps {
  value: string;
  icon: ElementType;
  label: string;
  currentValue: string;
  onSelect: (value: string) => void;
}

function Option({
  value,
  icon: Icon,
  label,
  currentValue,
  onSelect,
}: OptionProps) {
  const selected = currentValue === value;
  return (
    <ButtonCard
      className={classnames(selected && styles.optionSelected)}
      onClick={() => onSelect(value)}
    >
      <IconAndText
        icon={<Icon size={20} />}
        text={<Text weight="bold">{label}</Text>}
      />
    </ButtonCard>
  );
}

interface GenBailChoiceProps {
  name?: string;
}

export default function GenBailChoice({
  name = "genBail",
}: GenBailChoiceProps) {
  const [field, , helpers] = useField<string>(name);
  const { selectTab } = Tabs.useActiveTab();

  function selectAndAdvance(value: string) {
    helpers.setValue(value);
    // L'onglet "bail" n'est monté qu'une fois le choix fait : la présélection
    // (2e argument) bascule dessus dès qu'il devient disponible.
    selectTab("bail", true);
  }

  return (
    <div className={styles.group}>
      <Option
        value="false"
        icon={IconFileText}
        label="J'ai déjà un bail, ne pas générer de bail à nouveau"
        currentValue={field.value}
        onSelect={selectAndAdvance}
      />
      <Option
        value="true"
        icon={IconPencil}
        label="Je n'ai pas de bail, je souhaite en générer un"
        currentValue={field.value}
        onSelect={selectAndAdvance}
      />
    </div>
  );
}
